export default "<h3 mat-dialog-title>{{'PROTOCOL' | translate}}</h3>\n\n"